export type LogoVariant = "flat" | "square";

export const LOGO_ASSETS: Record<LogoVariant, { src: string; alt: string }> = {
  flat: {
    src: "/logo/flat.svg",
    alt: "Build-a-Dress logo",
  },
  square: {
    src: "/logo/square.svg",
    alt: "Build-a-Dress mark",
  },
};

export const LOGO_SIZE_MAP = {
  flat: {
    sm: { width: 80, height: 24 },
    md: { width: 120, height: 36 },
    lg: { width: 160, height: 48 },
    xl: { width: 200, height: 60 },
  },
  square: {
    sm: { width: 24, height: 24 },
    md: { width: 32, height: 32 },
    lg: { width: 40, height: 40 },
    xl: { width: 48, height: 48 },
  },
} as const;

export type LogoSize = keyof (typeof LOGO_SIZE_MAP)["flat"];
